import type { TFunction } from "i18next";
import type { menuItems } from "./ThreeDotsDropdownMenu";

export const getProjectMenuItems = (t: TFunction): menuItems => [
  {
    menuItemText: t("general.modify"),
    itemId: t("general.modify"),
    icon: "PencilAltIcon",
    disabled: false,
  },
  {
    menuItemText: t("general.duplicateProject"),
    itemId: "DuplicateProject",
    icon: "SaveAsIcon",
  },
  {
    menuItemText: t("general.makeTemplate"),
    itemId: "Fait template",
    icon: "SaveAsIcon",
  },
  {
    menuItemText: t("general.delete"),
    itemId: t("general.delete"),
    icon: "TrashIcon",
  },
];

export const getProjectGroupMenuItems = (t: TFunction, disabledDelete = false): menuItems => [
  {
    menuItemText: t("general.modify"),
    itemId: t("general.modify"),
    icon: "PencilAltIcon",
  },
  {
    menuItemText: t("general.duplicateProjectGroup"),
    itemId: "DuplicateProjectGroup",
    icon: "SaveAsIcon",
  },
  {
    menuItemText: t("general.delete"),
    itemId: t("general.delete"),
    icon: "TrashIcon",
    disabled: disabledDelete,
    disabledTooltipText: disabledDelete ? t("tooltip.thisCourseHasBeenPublished") : "",
  },
];
